const spacing = {
	space2: `${2 / 16}rem`,
	space4: `${4 / 16}rem`,
	space8: `${8 / 16}rem`,
	space12: `${12 / 16}rem`,
	space16: `${16 / 16}rem`,
	space24: `${24 / 16}rem`,
	space32: `${32 / 16}rem`,
	space40: `${40 / 16}rem`,
	space48: `${48 / 16}rem`,
	space64: `${64 / 16}rem`,
	space96: `${96 / 16}rem`,
	space128: `${128 / 16}rem`,
	space160: `${160 / 16}rem`,
	space196: `${196 / 16}rem`,
	em2: `${2 / 16}em`,
	em4: `${4 / 16}em`,
	em8: `${8 / 16}em`,
	em12: `${12 / 16}em`,
	em16: `${16 / 16}em`,
	em24: `${24 / 16}em`,
	em32: `${32 / 16}em`,
	em40: `${40 / 16}em`,
	em48: `${48 / 16}em`,
	em64: `${64 / 16}em`,
	em96: `${96 / 16}em`,
	em128: `${128 / 16}em`,
	em160: `${160 / 16}em`,
	em196: `${196 / 16}em`,
};

const globalSpacingTokens = {
	space1: spacing.space2,
	space2: spacing.space4,
	space3: spacing.space8,
	space4: spacing.space12,
	space5: spacing.space16,
	space6: spacing.space24,
	space7: spacing.space32,
	space8: spacing.space40,
	space9: spacing.space48,
	space10: spacing.space64,
	space11: spacing.space96,
	space12: spacing.space128,
	space13: spacing.space160,
	space14: spacing.space196,
	'em-space1': spacing.em2,
	'em-space2': spacing.em4,
	'em-space3': spacing.em8,
	'em-space4': spacing.em12,
	'em-space5': spacing.em16,
	'em-space6': spacing.em24,
	'em-space7': spacing.em32,
	'em-space8': spacing.em40,
	'em-space9': spacing.em48,
	'em-space10': spacing.em64,
	'em-space11': spacing.em96,
	'em-space12': spacing.em128,
	'em-space13': spacing.em160,
	'em-space14': spacing.em196,
};

const pageSpacingTokens = {
	xxs: globalSpacingTokens.space2,
	xs: globalSpacingTokens.space3,
	s: globalSpacingTokens.space5,
	m: globalSpacingTokens.space7,
	l: globalSpacingTokens.space9,
	xl: globalSpacingTokens.space11,
};

export default spacing;
export { spacing, globalSpacingTokens, pageSpacingTokens };
